module.exports = __webpack_public_path__ + "assets/4157d5c19d2f78aeadf1ef0e62cadbc3.mp4";